import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button, Image} from '@udemy/react-core-components';
import {udLink} from '@udemy/ud-data';

import styles from './subcategories-section.module.less';

interface SubcategoriesSectionProps {
    jumpLinkHandler(): void;
}

export const SubcategoriesSection = ({jumpLinkHandler}: SubcategoriesSectionProps) => {
    const {gettext} = useI18n();

    return (
        <div className="section">
            <div className="section-column image-container">
                <Image
                    className="placeholder-image"
                    src={udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/learning-for-you-v3.jpg',
                    )}
                    srcSet={`${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/learning-for-you-v3.jpg',
                    )} 1x, ${udLink.toStorageStaticAsset(
                        'browse_components/free-on-udemy/learning-for-you-2x-v3.jpg',
                    )} 2x`}
                    width={450}
                    height={450}
                    data-purpose="section-image"
                    alt=""
                />
            </div>
            <div className="section-column">
                <h2 className="ud-heading-serif-xxl section-title" data-purpose="section-title">
                    {gettext('Skills that suit you')}
                </h2>
                <p className="ud-text-md section-text">
                    {gettext(
                        'Learn valuable, practical skills from free online video courses. ' +
                            'Explore tech essentials and keep pace with change. Become more focused and productive. ' +
                            'Top it off with courses that round out your skills and enrich your day to day.',
                    )}
                </p>
                <div data-purpose="sub-category-links" className={styles['link-tags-container']}>
                    <Button udStyle="ghost" size="medium" onClick={jumpLinkHandler}>
                        {gettext('See more')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
